<template>
  <div>
    <b-row>
      <b-col>
        <div class="card mb-3">
          <div class="card-header bg-dark text-white">
            <h6 class="mb-0"><font-awesome-icon icon="user" /> Computation Table</h6>
          </div>
          <div class="card-body position-relative">
            <b-row align-v="center" class="loader" v-if="is_saving">
              <b-col>
                <b-spinner></b-spinner>
                <br><br>
                <strong>Loading</strong>
              </b-col>
            </b-row>
            <table class="table table-bordered">
              <tr>
                <td><h4>Position : {{result.job_description.description}}</h4></td>
                <td><h4>Daily Rate : {{result.job_description.daily_rate.other_formats.format_1}}</h4></td>
              </tr>
            </table>
            <table class="table table-bordered">
              <tr>
                <th class="text-center">Regular Hours</th>
                <th class="text-center">OT Hours</th>
                <th class="text-center">ND Hours</th>
                <th class="text-center">Regular Amount</th>
                <th class="text-center">OT Amount</th>
                <th class="text-center">ND Amount</th>
                <th class="text-center">Total Amount</th>
              </tr>
              <tr v-for="computation in result.results">
                <td class="text-center">{{computation.regular}}</td>
                <td class="text-center">{{computation.ot}}</td>
                <td class="text-center">{{computation.nd}}</td>
                <td class="text-center">{{computation.regular_amount}}</td>
                <td class="text-center">{{computation.ot_amount}}</td>
                <td class="text-center">{{computation.nd_amount}}</td>
                <td class="text-center">{{computation.total_amount}}</td>
              </tr>
            </table>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
    import FormComponent from './Form.vue';
    export default {
      components: {FormComponent},
      data() {
        return {
          'result':{},
          is_saving:false,
          'id':''
        }
      },
      created(){
        if(typeof this.$route.params.id !== 'undefined'){

          this.id=this.$route.params.id;
          this.get();
        }
      },
      methods: {
        get(){
          this.is_saving=true;
          this.axios.get('maintenance/job_descriptions/computation',{params:{id:this.$route.params.id}}).then(response => {
            this.result=response.data;
            this.is_saving=false;
          }).catch(error => console.log(error));
        },
      }
    }
</script>
